import { BASE_ROUTE, RouteParams } from "../../../constants";

export const BASE_PROCESSES_ROUTE = `${BASE_ROUTE}/processes`;

export const ProcessPages = {
  reports: {
    path: `/processes-reports`,
    generateLink: (organisationId: string | number, projectId: number | string) =>
      `/${BASE_PROCESSES_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/processes-reports`
  },
  processRoleMapping: {
    path: `/project-processes/role-mapping`,
    generateLink: (organisationId: string | number, projectId: number | string) =>
      `/${BASE_PROCESSES_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/project-processes/role-mapping`
  }
};
